'use client';

import {createContext, useState, useMemo, useContext, useEffect} from "react";
import {createCase, deleteCase, editCase, getCaseList, promoteTempCase} from "../../../api/CaseAPI";
import {Case} from "../legal/newCase/form/newCaseForm";


const CasesContext = createContext({} as {
    casesList: Case[],
    selectedCase: Case | null | undefined,
    handleSelectCase: (chosenCase: Case | null) => void,
    handleGetCasesList: () => void,
    handleAddNewCase: (caseName: string, caseDescription: string, isTemp: boolean) => Promise<any>,
    handleEditCase: (caseId: string, caseName: string, caseDescription: string, isTemp: boolean) => void,
    handleDeleteCase: (caseId: string) => Promise<any>,
    handlePromoteTempCase: (caseId: string) => void,
});

export const CasesProvider = ({children}) => {


    const [casesList, setCasesList] = useState<Case[]>([]);
    const [selectedCase, setSelectedCase] = useState<Case>();

    const handleSelectCase = (chosenCase: Case | null) => {
        if (!chosenCase && casesList.length > 0) {
            setSelectedCase(casesList[0]);
        } else if (!chosenCase) {
            setSelectedCase(undefined);
        } else {
            setSelectedCase(chosenCase);
        }
    };

    const handleGetCasesList = () => {
        getCaseList().then(value => {
            const sortedCases = value.sort((a, b) => {
                return new Date(b.created).getTime() - new Date(a.created).getTime();
            });
            setCasesList(sortedCases);
        });
    };

    const handleEditCase = (caseId: string, caseName: string, caseDescription: string, isTemp: boolean) => {
        return new Promise((resolve, reject) => {
            editCase(caseId, caseName, caseDescription, isTemp).then((editedCase) => {
                handleGetCasesList();
                resolve(editedCase);
            });
        });
    };

    const handleDeleteCase = async (caseId: string) => {
        try {
            const res = await deleteCase(caseId);
            handleGetCasesList();
            setSelectedCase(undefined);
            return res;
        } catch (error) {
            console.log("middle");
            throw error;
        };
    };

    const handleAddNewCase = async (caseName: string, caseDescription: string, isTemp: boolean) => {
        const res = await createCase(caseName, caseDescription, isTemp);
        handleGetCasesList();
        setSelectedCase(res);
        return res;
    };

    const handlePromoteTempCase = (caseId: string) => {
        promoteTempCase(caseId).then((res) =>
            console.log(res)
        );
    };

    useEffect(() => {
        handleGetCasesList();
    }, []);

    const value = useMemo(() => ({casesList, selectedCase, handleSelectCase, handleEditCase, handleGetCasesList, handleDeleteCase, handleAddNewCase, handlePromoteTempCase}), [casesList, selectedCase]);

    return (
        <CasesContext.Provider value={value}>
            {children}
        </CasesContext.Provider>
    );
};

export const useCases = () => useContext(CasesContext);
